import * as React         from 'react'
import { ReactComponent } from '../../types'

type Injector <P> = (Component: ReactComponent<P>) => React.SFC<P>

export default function <P, EP> (extraProps: EP): Injector<P> {
  return function (Component) {
    return (props: P) => (
      <Component
        {...props}
        {...extraProps}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/hocs/propsProxy.tsx